import * as React from 'react'
import { Divider } from '../../shared/Divider'
import DriverDataStage from './DriverDataStage'
import CardsStage from './CardsStage'

const BasicForm = () => {
  return (
    <section className="tw-space-y-6 tw-p-6">
      <DriverDataStage />
      <Divider />
      <CardsStage />
    </section>
  )
}

export default BasicForm
